'use strict';

function get(url, callback) {
  let req = new XMLHttpRequest();
  req.open("GET", url);
  req.onload = callback;
  req.send();
  return req;
}

function post(url, data, callback) {
  let req = new XMLHttpRequest();
  req.open("POST", url);
  req.onload = callback;
  req.send(data);
  return req;
}

module.exports = {
  get,
  post
}



// WEBPACK FOOTER //
// ../autor/src/http.js